import AccountNav from "../../../../logic/navigation/accountNav";
import AccountLayout from "../structure/AccountLayout";
import AccountTertiaryNav from "../structure/AccountTertiaryNav";
import {Button} from "../../../../../components/general/input/Button";
import {useState} from "react";
import Popup from "../../../../../components/general/popup/Popup";
import Dialog from "../../../general/dialog/Dialog";
import DialogTitle from "../../../general/dialog/DialogTitle";
import DialogMessage from "../../../general/dialog/DialogMessage";
import Input from "../../../../../components/general/input/Input";
import DialogButtonContainer from "../../../general/dialog/DialogButtonContainer";
import DialogButton, {DIALOG_BUTTON_TYPE} from "../../../general/dialog/DialogButton";
import useAuthRequest from "../../../../services/state/request/useAuthRequest";
import {request} from "../../../../../res/rest/restRequest";
import {useNavigate} from "react-router-dom";
import useLogOut from "../../../../../components/state/account/useLogOut";
import VendorNav from "../../../../logic/navigation/vendorNav";
import useIsAccountPage from "../structure/useIsAccountPage";

const acctBreadcrumbTrail = [AccountNav.items.home, AccountNav.items.settings, {...AccountNav.items.deactivate, selected: true}];
const vendBreadcrumbTrail = [VendorNav.items.home, VendorNav.items.settings, {...VendorNav.items.deactivate, selected: true}];

const deleteAccount = (session) => {
    const delAccount = request.model("c_bpartner")
        .id(session.bPartnerID)
        .data({ isActive: false })
        .put(session);
    const delUser = request.model("ad_user")
        .id(session.userID)
        .data({ isActive: false })
        .put(session);
    return Promise.all([delAccount, delUser]);
}

const DeactivateAccountContent = () => {

    const [ showDelete, setShowDelete ] = useState(false);
    const [ showDeleted, setShowDeleted ] = useState(false);
    const [ warning, setWarning ] = useState(false);
    const [ input, setInput ] = useState("");

    const logOut = useLogOut();
    const navigate = useNavigate();

    const {
        loading,
        sendIt
    } = useAuthRequest();

    const onDone = () => {
        logOut();
        navigate("/");
    }

    const onCancel = () => {
        setInput("");
        setShowDelete(false);
        setWarning(false);
    }

    const onDelete = () => {
        if(input.toLowerCase() === "delete") {
            setShowDelete(false);
            sendIt(deleteAccount, () => setShowDeleted(true))
        } else {
            setWarning(true);
        }
    }

    return (
        <div className="acct-content">
            <p className="acct-h1">Delete Account</p>
            <p className="acct-val">Before deleting your account, please ensure you have downloaded and saved any records that may be important to you, such as those required for financial or personal reference. Once the deletion is complete, access to your account and its contents will no longer be available.</p>
            {showDeleted &&
                <Popup>
                    <Dialog>
                        <DialogTitle>Account Deleted</DialogTitle>
                        <DialogMessage>
                            Your account has been successfully deleted
                        </DialogMessage>
                        <DialogButtonContainer>
                            <DialogButton onClick={onDone}>Ok</DialogButton>
                        </DialogButtonContainer>
                    </Dialog>
                </Popup>
            }
            {showDelete &&
                <Popup>
                    <Dialog>
                        <DialogTitle>Delete Account</DialogTitle>
                        {warning &&
                            <DialogMessage>
                                <b>
                                    You must type the word delete, this is to protect against accidental deletion
                                </b>
                            </DialogMessage>
                        }
                        <DialogMessage>Please type <b>delete</b> below, and click the button, to delete your account</DialogMessage>
                        <Input hint="delete" style={{borderColor: "var(--warning)"}} onChange={e => setInput(e.target.value)} />
                        <DialogMessage />
                        <DialogButtonContainer>
                            <DialogButton type={DIALOG_BUTTON_TYPE.neutral} onClick={onCancel}>Cancel</DialogButton>
                            <DialogButton type={DIALOG_BUTTON_TYPE.negative} onClick={onDelete}>Delete</DialogButton>
                        </DialogButtonContainer>
                    </Dialog>
                </Popup>
            }
            <Button
                style={{backgroundColor: loading ? "var(--inactive)" : "var(--warning)"}}
                onClick={() => !loading && setShowDelete(true)}
            >
                Delete Account
            </Button>
        </div>
    )

}

const DeactivateLayout = () => {

    const isAccount = useIsAccountPage();
    const breadcrumbTrail = isAccount ? acctBreadcrumbTrail : vendBreadcrumbTrail;

    return (
        <AccountLayout breadcrumbTrail={breadcrumbTrail}>
            <AccountTertiaryNav navList={breadcrumbTrail[1].children} />
            <DeactivateAccountContent />
        </AccountLayout>
    )

}

export default DeactivateLayout;
